module.exports = __webpack_public_path__ + "img/avatar.28b780ce.png";